import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  UI_NAV_LABELS,
  UI_PAGE_TITLES,
} from '@/constants/uiLabels';

const PaymentSuccess = () => {
  const query = useMemo(() => new URLSearchParams(window.location.search), []);
  const type = query.get('type');
  const sessionId = query.get('session_id');
  const isSubscription = type === 'subscription';
  const isWalletRecharge = type === 'wallet_recharge';
  const returnPath = isWalletRecharge ? '/vendeur/wallet' : (isSubscription ? '/vendeur/subscribe-express' : '/vendeur');
  const returnLabel = isWalletRecharge
    ? `Retour au ${UI_NAV_LABELS.walletSeller.toLowerCase()}`
    : (isSubscription ? `Retour a l ${UI_PAGE_TITLES.subscriptionSeller.toLowerCase()}` : 'Retour au tableau de bord vendeur');
  const detailMessage = sessionId
    ? 'Stripe est desactive. Cette ancienne session de paiement ne peut plus etre confirmee.'
    : 'Cette page de confirmation Stripe n est plus utilisee. Les paiements passent maintenant par Mobile Money avec preuve de paiement.';

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-red-50 flex items-center justify-center p-6">
      <Card className="w-full max-w-xl border-amber-200 shadow-xl">
        <CardHeader className="text-center">
          <div className="mx-auto mb-3 w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-amber-600" />
          </div>
          <CardTitle className="text-3xl">Paiement par carte desactive</CardTitle>
          <CardDescription className="text-base">
            Coli Noki utilise maintenant Mobile Money avec validation admin.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4 text-center">
          <p className="text-lg font-medium text-gray-800">{detailMessage}</p>
          <p className="text-sm text-gray-600 bg-amber-50 border border-amber-200 rounded-md p-3">
            Si vous devez finaliser un paiement, revenez dans votre espace vendeur puis soumettez une preuve Mobile Money.
          </p>

          <div className="pt-2">
            <Button asChild className="bg-red-500 hover:bg-red-600">
              <Link to={returnPath}>
                {returnLabel}
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSuccess;

